import { whyChoose } from "./data";

export const WhyChooseUs = () => (
    <section id="why-us" className="bg-[#f0f9ff] py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto text-center mb-14">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">Why Choose Us</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Care That Puts You First
                </h2>
                <p className="mt-4 text-base leading-relaxed text-slate-600">
                    A dental visit should feel reassuring, not stressful. Here is what we focus on every single day.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="why-choose-grid">
                {whyChoose.map((w) => (
                    <article
                        key={w.title}
                        data-testid={`why-card-${w.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="bg-white rounded-2xl p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-sky-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
                    >
                        <span className="h-12 w-12 rounded-xl bg-teal-600 flex items-center justify-center mb-5 shadow-[0_8px_18px_rgba(13,148,136,0.3)]">
                            <w.icon className="h-6 w-6 text-white" strokeWidth={1.5} />
                        </span>
                        <h3 className="text-lg font-semibold text-slate-900 mb-2">{w.title}</h3>
                        <p className="text-sm leading-relaxed text-slate-500">{w.desc}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);
